<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header="<i class='fa fa-star'></i> Detail Pendanaan">
            <button type="button" @click="showModal" class="btn btn-outline-primary">Tambah Pendanaan</button>
            <br></br>
            <div v-if="isLoading" > 
            <center>
              <v-pulse></v-pulse>
            </center>
            </div>
            <div v-else class="table-responsive">

            <table class="table table-striped table-bordered table-hover" >
                <thead>
                  <tr>
                      <th>No</th> 
                      <th>Nama User</th>
                      <th>Sumbangan</th>
                      <th>Status</th>
                      <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="fundings.length > 0">
                    <tr v-for="(value,index) in fundings" :key="index">
                        <td>{{index+1}}</td>
                        <td v-if="value.user_id == null">
                            {{value.nama_user}}
                        </td>
                        <td v-else>
                            {{value.user_nama}}
                        </td>
                        <td>
                            <ul class="list-group" v-for="(item,index) in value.items" :key="index">
                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    {{item.nama_item}} 
                                    <span class="badge badge-primary">{{item.qty}} | {{item.satuan}}</span>
                                </li>
                            </ul>
                        </td>
                        <td v-if="value.confirm == '0'">
                            <b-badge href="#" variant="danger">Belum Konfirmasi</b-badge>
                        </td>
                        <td v-else>
                            <b-badge href="#" variant="success">Confirmed</b-badge>
                        </td>
                        <td>
                            <button type="button" @click="confirm(value.id)" class="btn btn-xs btn-outline-warning"><span class="fa fa-pencil"></span></button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <td colspan="5">
                        <center>
                            Tidak Ada Data
                        </center>
                    </td>
                </tbody>
              </table>
            </div>
          </b-card>
          <b-modal title="Buat Pendanaan" class="modal-primary" v-model="isModalVisible" @ok="addFunding">
            <b-form enctype="multipart/form-data">
                <b-form-group
                    v-if="!isAnonym"
                    label="Pilih User"
                    label-for="user">
                    <v-select v-model="selected" :options="users"></v-select>
                </b-form-group>
                 <b-form-group>
                    <b-form-checkbox @change="onChangeUser()" value="orange">Tidak Ada Di List</b-form-checkbox>
                </b-form-group>
                <b-form-group
                    v-if="isAnonym"
                    label="Nama Pendanaan"
                    label-for="nama">
                    <b-form-input v-model="funding.name" required id="nama" type="text" placeholder="Nama Donatur" autocomplete="Nama"></b-form-input>
                </b-form-group>
                <b-form-group
                    label="Pilih Item"
                    label-for="user">
                    <button type="button" @click="addItem()" class="btn btn-xs btn-outline-warning"><span class="fa fa-plus"></span></button>
                    <b-row v-for="(value,index) in selectedItem" :key="index" style="margin-top:5px">
                        <b-col sm="5">
                            <v-select v-model="value.title" :options="items"></v-select>
                        </b-col>
                        <b-col sm="3">
                            <b-form-input v-model="value.qty" required id="qty" type="text" placeholder="Jumlah" autocomplete="Jumlah"></b-form-input>
                        </b-col>
                        <b-col sm="3">
                            <button type="button" @click="removeItem(index)" class="btn btn-xs btn-outline-danger"><span class="fa fa-trash"></span></button>
                        </b-col>
                    </b-row>
                </b-form-group>
            </b-form>
        </b-modal>
        </b-col><!--/.col-->
      </b-row><!--/.row-->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import {getCache,storedCache} from '@/cache'
import constant from '../../utils/constant.js';
export default {
  data () {
    return {
        isAnonym:false,
        isLoading: true,
        isModalVisible: false,
        selected : null,
        selectedItem : [],
        item:{
            title: '',
            qty: ''
        },
        users : [],
        items : [],
        funding : {},
        fundings:[]
    }
  },
  created(){
     this.getFunding()
     this.getUser()
     this.getItem()
     this.selectedItem.push(Vue.util.extend({}, this.item)) 
  },
  beforeMount()
  {
    
  },
  watch: {
    '$route' : 'getFunding'
  },
  methods:{
        onChangeUser()
        {
            if(this.isAnonym == true)
            {
                this.isAnonym = false
            }else{
                this.isAnonym = true
            }
        },
        alert(message,type)
        {
            this.$notify({
                group: 'notif',
                title: 'Important message',
                text: message,
                duration: 1000,
                type: type
            });
        },
        addItem()
        {
            this.selectedItem.push(Vue.util.extend({}, this.item))
        },
        removeItem(index) {
            Vue.delete(this.selectedItem, index);
        },
        openSpinner()
        {
            this.isLoading = true
        },
        closeSpinner()
        {
            this.isLoading = false
        },
        confirm(id)
        {
            const token = localStorage.getItem(`user_token`);
            const community_id = localStorage.getItem('user_id');
            this.$swal({
            title: 'Konfirmasi ',
            text: 'Apakah anda yakin konfimasi user ini ?',
            type: 'error',
            showCancelButton: true,
            confirmButtonText: 'Yes Confirm!',
            cancelButtonText: 'No, Cancel!',
            showCloseButton: true,
            showLoaderOnConfirm: true
            }).then((result) => {
            if(result.value) {
                axios.put(constant._BASE_URL+"funding/"+id,"",{
                    headers:{
                        'Content-type': 'application/json',
                        'Authorization' : 'Bearer '+token,
                    }
                }).then(response => {
                        let message = response.data.success
                        console.log(message)
                        this.$swal('Konfirmasi', message , 'success')
                        this.getFunding()
                })
            } else {
        
            }
            })
        },
        getItem()
        {
            const token = localStorage.getItem(`user_token`);
            const community_id = localStorage.getItem('user_id');
            axios.get(constant._BASE_URL+"item",{ 
                headers: {
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
                }
            }).then(response => {
                    var item = response.data
                    storedCache('item'+community_id, item)

                    var items = getCache('item'+community_id)
                    for(let i=0;i<items.length;i++)
                    {
                        let data = {
                            'label' : items[i]['name'],
                            'value' : items[i]['id']
                        }
                        this.items.push(data)
                    }

            }).catch(error => {
                    alert(error)
                    var items = getCache('item'+community_id)
                    for(let i=0;i<items.length;i++)
                    {
                        let data = {
                            'label' : items[i]['name'],
                            'value' : items[i]['id']
                        }
                        this.items.push(data)
                    }
            });
        },
        getUser()
        {
            const token = localStorage.getItem(`user_token`);
            const community_id = localStorage.getItem('user_id');
            axios.get(constant._BASE_URL+"user",{ 
                headers: {
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
                }
            }).then(response => {
                    var user = response.data
                    storedCache('users'+community_id, user)

                    var users = getCache('users'+community_id)
                    for(let i=0;i<users.length;i++)
                    {
                        let data = {
                            'label' : users[i]['name'],
                            'value' : users[i]['id']
                        }
                        this.users.push(data)
                    }

            }).catch(error => {
                    alert(error)
                    var users = getCache('users'+community_id)
                    for(let i=0;i<users.length;i++)
                    {
                        let data = {
                            'label' : users[i]['name'],
                            'value' : users[i]['id']
                        }
                        this.users.push(data)
                    }
            });
        },
        getFunding()
        {
            const token = localStorage.getItem(`user_token`);
            const community_id = localStorage.getItem('user_id');
            this.openSpinner()
            axios.get(constant._BASE_URL+"funding/"+this.$route.params.id,{
                headers:{
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+token,
                }
            }).then(response =>{
                storedCache(`funding_detail`+community_id, response.data)
                this.fundings = getCache(`funding_detail`+community_id)
                this.closeSpinner()
            }).catch(error => {
                console.log(error)
                this.fundings = getCache(`funding_detail`+community_id)
                this.closeSpinner()
            });
        },
        showModal() {
            this.selectedItem = []
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        addFunding(e)
        {
            const token = localStorage.getItem(`user_token`);
            const community_id = localStorage.getItem('user_id');
            e.preventDefault()
            let formData = new FormData()
            if (this.selectedItem.length > 0) {
                for (var i = 0; i < this.selectedItem.length; i++) {
                    let attachment = this.selectedItem[i];
                    let itemId = this.selectedItem[i].title.value
                    let itemQty = this.selectedItem[i].qty
                    formData.append('itemId[]', itemId)
                    formData.append('itemQty[]', itemQty)
                    
                }
            }
            formData.append('funding_id', this.$route.params.id)
            if(this.isAnonym == true)
            {
                formData.append('nama_donatur',this.funding.name)
                formData.append('donatur_id','')
            }else{
                formData.append('nama_donatur','')
                formData.append('donatur_id',this.selected.value)
            }
            axios.post(constant._BASE_URL+"funding/tambah",formData,{
                headers:{
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+token,
                }
            }).then(response =>{
                this.getFunding()
                this.alert(response.data['success'],'success')
            }).catch(error => {
                alert(error)
            })
            this.closeModal()
        }
    }
}
</script>
<style scoped>
.imageFile {
  height: 150px;
}
.imageHome {
  width: 30%;
  display: inline-block;
  margin-left: 0dp;
  margin-right: 0dp;
}
</style>



// WEBPACK FOOTER //
// src/components/funding/DetailFunding.vue